var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotspots"},[_c('ul',_vm._l((_vm.spotsList),function(item,idx){return _c('li',{key:item.title,class:['spot', _vm.curIdx === idx?'selected':''],on:{"click":function($event){return _vm.clickToggleSpot(item, idx)}}},[_vm._v(_vm._s(item.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }